import React from 'react'
import Header from '../common/header'
import Footer from '../common/footer'
import { Outlet } from 'react-router-dom'

export const DefaultLayout = () => {
    return (
        <>
            <Header />
            <Outlet />
            <Footer />
        </>
    )
}
